import InfoBlock from "./InfoBlock";

import "./InfoBlock.scss";

export * from "./InfoBlock.types";

export { InfoBlock };
